import { render, staticRenderFns } from "./NavBarContent.vue?vue&type=template&id=c521e206&scoped=true"
import script from "./NavBarContent.vue?vue&type=script&lang=js"
export * from "./NavBarContent.vue?vue&type=script&lang=js"
import style0 from "./NavBarContent.vue?vue&type=style&index=0&id=c521e206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.7.4_webpack@5.103.0__ejs@3.1.1_beeed02dd832a1e8a219df4e9dcab5f9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c521e206",
  null
  
)

export default component.exports